import navigationReducer from "./navigation";

import { logger } from "./middlewares";

interface State {
  navigation: any;
}

export const initialState: State = {
  navigation: navigationReducer.initialState,
};

export default function mainReducer(state: State, action: object) {
  // Receiving previous state here
  const { navigation } = state;

  // Receiving current state here
  const currentState = {
    navigation: navigationReducer.reducer(navigation, action),

  };

  // Middlewares
  // logger(action, state, currentState);

  return currentState;
}
